<!--
  --
  -- 免責補償アイテム
  --
  -->
<template>
  <v-radio
    :value="item.id"
  >
    <template #label>
      <div class="c-options-insurance-item">

        <!-- アイテム名 -->
        <div class="text--primary">
          <span>{{item.name}}</span>
        </div>

        <!-- 単価 -->
        <div v-if="item.unitCharge > 0" class="text-body-2">
          <span class="mr-2 text--primary">{{item.unitCharge | comma}}</span>
          <span>円/日</span>
        </div>

      </div>
    </template>
  </v-radio>
</template>

<script>
export default {
  name: 'CInsuranceItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
